import React,{useState,useEffect,useRef} from "react";
import ParticipantsDashboardHead from "../../Header/participants_head";
import  "../join/dashboards.css";
import { useSelector, useDispatch } from "react-redux";
import axiosInstance from "../../../services/axios";
import { useWs } from "../../../websocket/test";
import { TopicProvider } from "../../../redux/actions/websocket_actions/topic_action";
import TimerFunction from "../../../common/js/debate_timer";
import  secureLocalStorage  from  "react-secure-storage";
import { WebsocketContext } from "../../../websocket/context";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { getAllMember } from "../../../redux/actions/get_all_joined_member_action";
import { RoomIdProvider } from "../../../redux/actions/websocket_actions/roomId_action";
import TeamTimer from "../../../common/js/team_timer";
import { getCounterStatement,updateCounterStatement } from "../../../redux/actions/websocket_actions/counter_statements_action";
import { useNavigate } from "react-router-dom";
import { clearAllSecureLocalStorage } from "../../../utils/utils";

function Participants(){
    const dispatch = useDispatch();
    const location = useLocation();
    const code = location.state.code;
    const room_id = location.state.room_id;
    const team_side = location.state.team_side;
    const virtual_id = location.state.virtual_id
    const navigate = useNavigate();
    

    const {roomId} = useSelector((state)=>state.roomIdReducer);
   

    if(roomId === null){
        dispatch(RoomIdProvider(room_id));

    }
 
    
    const [ready, val, send] = useContext(WebsocketContext);
    const [debateDetails,setDebateDetails] = useState(false);
    const [getAvatars,setGetAvatars] = useState(false)
    const [finish,setFinish] = useState(false)

    const topic = useSelector((state)=>state.topicReducer);
    // const avatar = useSelector((state)=>state.avatarReducer);
    const {avatars} = useSelector((state)=>state.getAllAvatarReducer);

    const skin_color_obj = {"skin-1":"skin-color-1.png","skin-2":"skin-color-2.png","skin-3":"skin-color-3.png"}
    const male_hair_color_obj = {"hair-1":"male-hair-color-1.png","hair-2":"male-hair-color-2.png","hair-3":"male-hair-color-3.png","hair-4":"male-hair-color-4.png"}
    const female_hair_color_obj = {"hair-5":"female-hair-color-1.png","hair-6":"female-hair-color-2.png","hair-7":"female-hair-color-3.png","hair-8":"female-hair-color-4.png"}
    const dress= {"dress-1":"clothe-color-1.png","dress-2":"clothe-color-2.png","dress-3":"clothe-color-3.png","dress-4":"clothe-color-4.png"}
    

    useEffect(()=>{
        if(ready){
            send(JSON.stringify({action:"joined_member"}));

        }
        
    },[ready,send])

    useEffect(()=>{
        var temp = JSON.parse(val)
        if(temp.action === 'topic'){
            dispatch(TopicProvider(temp.action,temp.data))
        }
        if(temp.action === "joined_member"){
            dispatch(getAllMember(code,team_side));

        }
        if(temp.action === "announce_winner"){
            clearAllSecureLocalStorage();
            navigate("/winner",{state:{team:temp.data.winner}})
        }
        // if(temp.action === "status"){
        //     if(temp.data.team === team_side){
        //         if (temp.data.status){
        //             setFinish(temp.data.status)
        //         }
        //     }
        // }
    },[val])

   
    useEffect(()=>{
        return ()=>{
            axiosInstance.get("/join/details/").then((res) => {
                setDebateDetails(res.data);
            }).catch((error) => {
                console.log(error)
            }) 
        }
       
    },[]);

    useEffect(()=>{
        return()=>{
            axiosInstance.get(`/details/check/finish/${virtual_id}/${team_side}`).then((res)=>{
                setFinish(res.data.status)
            })
        }
    },[])
    const sendMessage = ()=>{
        send(JSON.stringify({action:"test"}));
    }

    
    return(
        <div>
        <ParticipantsDashboardHead/>
        <div className='inner-page-wrapper'>
        <div className={"debate-title-header"}>
            <div className="container d-flex align-items-center flex-column">
                <div className="title">
                {debateDetails ? debateDetails.debate.title:""}
                </div>
                {topic.action 
                ?
                <h1><a id="current_topic_audience">{topic.action === 'topic' ? topic.data : 'No Topic'}</a></h1>
                :
                <h1><a id="current_topic_audience">{secureLocalStorage.getItem("topic")===null ? `Topic Will be display here`:secureLocalStorage.getItem("topic")} </a></h1>

                } 
            </div>
        </div>


        <div id="myProgress">
          <div id="myBar"></div>
        </div>

        <div id="d"></div>



        <div className="debate-team-box">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-md-6">
                        <h4>Your Team</h4>
                        <div className="team">
                             {/* {% for avatar in avatars %}
                             {% if avatar.team_side == team %}
                             {% if avatar.profile_image_id %}
                             <div className="member" id="{{avatar.user_id}}">
                                <img src="{{avatar.profile_image.profile_image.url}}" style="width: 100px; height: 100px; border-radius: 50%; background-position: center center; background-size: cover;" >
                            </div>
                             {% else %} */}
                             {avatars.length ?
                                <>
                            
                                {avatars.map((avatar,index)=>
                                <div className="member" key={index}>
                                <div className={avatar.gender === "male"? "avatar male":"avatar female"}>
                                    <div className="hair">
                                        <img src={ process.env.PUBLIC_URL+`img/${avatar.gender === "female"? female_hair_color_obj[avatar.hair_color]:male_hair_color_obj[avatar.hair_color]}` } width="69" alt="" title="" />
                                    </div>
                                    <div className="face">
                                        <img src={ process.env.PUBLIC_URL+`img/${skin_color_obj[avatar.skin_tone]}` }  width="46" alt="" title="" />
                                    </div>
                                    <div className="body">
                                        <img src={ process.env.PUBLIC_URL+`img/${dress[avatar.dress_color]}` } width="53" alt="" title="" />
                                    </div>
                                </div>
                                    <span class="you">You</span>
                                </div> 
                                )} 

                                {/* {avatars.map((avatar,index)=>
                                <div className="member" key={index}>
                                <div className={avatar.gender === "female"? "avatar male":"avatar female d-none"}>
                                    <div className="hair">
                                        <img src={ process.env.PUBLIC_URL+`img/${male_hair_color_obj[avatar.hair_color]}` } width="69" alt="" title="" />
                                    </div>
                                    <div className="face">
                                        <img src={ process.env.PUBLIC_URL+`img/${skin_color_obj[avatar.skin_tone]}` }  width="46" alt="" title="" />
                                    </div>
                                    <div className="body">
                                        <img src={ process.env.PUBLIC_URL+`img/${dress[avatar.dress_color]}` } width="53" alt="" title="" />
                                    </div>
                                </div>
                                    <span class="you">You</span>
                                </div> 
                                )}  */}
                                
                                </>  
                                
                            :
                            "No avatar Found Something went Wrong"
                            }
                            {/* {% endif %} */}
                            {/* {% endif %} */}
                            {/* {% endfor %} */}

                            {/* {% comment %}
                            {% for avatar in avatars %}

                                {% if avatar.profile_image %}    
                                <div class="member" id="
                                {{data.user_id}}">
                                <div class="member">
                                    <img src="{{avatar.profile_image.profile_image.url}}" alt="">
                                </div>
                                </div>
                                {% else %}
                                <div class="avatar male">
                                    <div class="hair">
                                        <img src="{{avatar.haircolor.hair.url}}" width="69" alt="" title="" />
                                    </div>
                                    <div class="face">
                                        <img src="{{avatar.skincolor.skin.url}}" width="46" alt="" title="" />
                                        </div>
                                    <div class="body">
                                        <img src="{{avatar.dresscolor.clothe.url}}" width="53" alt="" title="" />
                                    </div>
                                    <span class="you">You</span>

                                </div>

                                {% endif %}
                            {% endfor %}

                            <div class="member">
                                <div class="avatar male">
                                    <div class="hair">
                                        <img src="{% static 'img/male-hair-color-1.png' %}" width="69" alt="" title="" />
                                    </div>
                                    <div class="face">
                                        <img src="{% static 'img/skin-color-1.png' %}" width="46" alt="" title="" />
                                    </div>
                                    <div class="body">
                                        <img src="{% static 'img/clothe-color-1.png' %}" width="53" alt="" title="" />
                                    </div>
                                </div>
                            </div>
                            {% endcomment %} */}

                        </div>
                    </div>
                        
                    <div className="col-lg-5 offset-lg-2 col-md-6 d-flex flex-column align-items-center right-info">
                    {debateDetails.debate
                            ?
                            (finish === false
                                ?
                        <div className="timerWrap">
                            <div className="timerTitle">
                                Time Left
                            </div>
                           
                            <TeamTimer team={team_side} total_hour={debateDetails.debate.total_hour?debateDetails.debate.total_hour:"0"} total_minutes={debateDetails.debate.total_minutes?debateDetails.debate.total_minutes:"0"} joined_as="participant"/>
                            
                            <div className="timeLabels">
                                <span>hr</span>
                                <span>min</span>
                                <span>sec</span>
                            </div>
                        </div>
                        :
                        ""
                        )
                        :
                        ""
                        }
                       
                        {debateDetails ? debateDetails.debate.type.type === 'intermediate' ?
                        (finish === false ?
                        <>
                        <div className="counter-statement-wrap">
                            <span  id="leftsidecounter" onClick={()=>sendMessage()} className="btn btn-primary">Give Counter statement</span>
                            <div className="counter-statement-left">
                                You’ve <strong>{debateDetails.details.counter_statement}</strong> left
                            </div>
                           
                        </div>

                        <div className="ask-for-time">
                            <a onclick="ExtraTimeRequest('leftteam')" href="#" class="d-inline-flex align-items-center">
                                <img src={process.env.PUBLIC_URL+ 'img/timer-watch-icon.png' } alt="" title="" width="16" class="mr-2" />
                                Ask for extra time
                            </a>
                        </div>
                        </>
                        :
                        ""
                        )   
                        :
                        ""
                        :
                        ""
                        }

                       
                    </div>
                  
                    
                    
                    
                </div>
            </div>
        </div>
    </div>
  


        </div>
    );
}

export default Participants;